import React, { useState } from 'react';
import { Platform, StyleSheet, TouchableOpacity, View } from 'react-native';
import { Icon } from "../../../icon/Icon";
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens } from "@voltmoney/schema";
import { Typography } from "../../../typography/Typography";
const AccordionItem = ({ id = "", title, children, showDivider, isDarkMode = false }) => {
    const [expanded, setExpanded] = useState(false);
    const toggleAccordion = () => {
        setExpanded(!expanded);
    };
    return (React.createElement(View, { nativeID: id, style: [styles.container, showDivider ? {
                borderBottomWidth: 1,
                borderColor: '#E4E7EC',
            } : {}] },
        React.createElement(TouchableOpacity, { onPress: toggleAccordion, style: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
            } },
            React.createElement(Typography, { label: title, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_500, fontWeight: '600', lineHeight: 20 }),
            expanded
                ? React.createElement(Icon, { size: IconSizeTokens.XL, name: IconTokens.ChevronUpV2, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_500 })
                : React.createElement(Icon, { size: IconSizeTokens.XL, name: IconTokens.ChevronDownV2, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_500 })),
        expanded && React.createElement(View, { style: styles.content }, children)));
};
const styles = StyleSheet.create({
    container: {
        paddingVertical: 16,
    },
    title: {
        fontSize: 14,
        fontWeight: Platform.OS !== "web" ? 'bold' : '600',
        fontFamily: 'Inter',
        lineHeight: 20,
    },
    content: {
        marginTop: 5,
    },
});
export default AccordionItem;
